const ALLOWED_EXPLICIT_CONTENT_PROBABILITY = 0.9; // from 0 to 1
export const getIsExplicitContent = (predictions) => {
    const { hentai = 0, porn = 0, sexy = 0 } = predictions?.data ?? {};
    const explicitContentProbability = porn + sexy + hentai;
    return explicitContentProbability >= ALLOWED_EXPLICIT_CONTENT_PROBABILITY;
};
